<template>
  <v-card class="odeme-formu__body mx-auto" flat>
    <v-card-title class="justify-center">
      <h1 class="odeme-formu__body-title">{{ title }}</h1>
    </v-card-title>
    <v-card-text>
      <p class="odeme-formu__body-description text-center">
        {{ description1 }}
      </p>
      <div class="odeme-formu__banks-area" v-if="bank">
        <div class="odeme-formu__banks-area-header">
          <span class="odeme-formu__banks-area-header-title">{{ title2 }}</span>
        </div>
        <div class="odeme-formu__banks-area-body">
          <template v-for="(item, index) in bank.fields">
            <template v-if="item[2] === 'dateTime' && index && item">
              <v-text-field
                :key="index"
                :label="item[1]"
                v-model="bankFieldValues[index]"
                v-mask="'##/##/####'"
                placeholder="00/00/0000"
              ></v-text-field>
            </template>
            <template v-else>
              <v-text-field
                :key="index"
                :label="item[1]"
                v-model="bankFieldValues[index]"
              ></v-text-field>
            </template>
          </template>
        </div>
      </div>
      <!-- <p class="odeme-formu__description2 text-center">{{ description2 }}</p> -->
    </v-card-text>
    <v-card-actions v-if="data">
      <div class="odeme-formu__tutar-area">
        <div class="odeme-formu__tutar-area-yatirim-text">
          Yatırım Miktarı :
          <strong>{{ amount }} (TRY)</strong>
        </div>
        <div class="odeme-formu__tutar-area-tutar">
          <button
            @click="handleGonder"
            type="button"
            class="odeme-formu__tutar-area-tutar-button btn btn-secondary"
          >
            Gönder
          </button>
        </div>
      </div>
    </v-card-actions>
    <v-divider class="py-5"></v-divider>
    <v-btn @click="goBack">&lt; </v-btn>
  </v-card>
</template>

<script>
import axios from "axios";
import banksData from "../banks.json";
export default {
  name: "step2",
  props: {
    preTransactionId: String,
    selectedBank: Number,
    selectedPaymentMethod: String,
    amount: String,
  },
  data() {
    return {
      data: null,
      menu: false,
      date: null,
      selectedSlot: null,
      title: "",
      title2: "",
      description1: "",
      description2: "",
      buttonText: "Kopyala",
      redirectUrl: "",
      customer: {},
      bank: {},
      bankFieldValues: null,
    };
  },
  created() {
    this.getTransactionDetails();
    this.initial();
    this.data = {
      banks: banksData.banks,
      preTransaction: {
        // TEST transaction
        requestType: "deposit",
        transactionId: "12345",
        payment: {
          paymentMethod: "banktransfer",
          amount: "50",
          currency: "TRY",
        },
        customer: {
          fullName: "Ali Taş",
          email: "ali.tas@email.com",
          phone: "+905555555555",
          country: "TR",
          city: "Istanbul",
        },
        notificationUrl: "https://api.destpay.com/test-notification-url",
        redirectUrl: "https://www.testwebsite.com",
      },
    };
  },
  watch: {
    selectedBank(newVal) {
      console.log(newVal);
      this.bank = banksData.banks.find((e) => e.id === newVal);
      this.bankFieldValues = Array(this.bank.fields.length).fill("");
      this.setDescriptions();
      console.log(this.bank);
    },
  },
  methods: {
    getTransactionDetails() {
      axios
        .get(
          `https://api.destpay.com/withdrawal-page-step2/${this.preTransactionId}/${this.selectedPaymentMethod}`
        )
        .then((response) => {
          if (response.data?.redirectUrl && response.data?.amount) {
            //this.data = response.data; // belki sonra egerki daha fazla transaction details lazim olursa
            this.amount = response.data.amount;
            this.redirectUrl = response.data.redirectUrl;
          } else {
            this.title = "";
            this.title2 = "";
            this.description1 = `Şu anda aktif hesap bulunmamaktadir, Lütfen daha sonra tekrar deneyiniz.`;
            this.data.banks = [];
          }
        })
        .catch((err) => console.log(err));
    },
    getCustomerObject() {
      // burada biz yeni bir customer objesi olusturucaz.
      const customer = { bank: this.selectedBank.name }; // banki ilk giriyoruz.
      console.log({ fields: this.bank.fields });
      for (let i = 0; i < this.bank.fields.length; i++) {
        const field = this.bank.fields[i];
        const fieldValue = field[0]; // 0 name 1 value
        const value = this.bankFieldValues[i];
        customer[fieldValue] = value;
      }

      return customer;
    },
    handleGonder() {
      if (!this.selectedBank) {
        this.setError("Lütfen İşlem yapmak istediğiniz bankayı seçiniz..");
        return;
      }

      const customerObject = this.getCustomerObject();

      axios
        .post(`https://api.destpay.com/checkPreTransaction-vue-wd`, {
          preTransactionId: this.preTransactionId,
          customer: customerObject,
        })
        .then((response) => {
          const result = response.data;
          this.$emit("nextPage", { result, redirectUrl: this.redirectUrl });
        })
        .catch((err) => console.log(err));
    },
    goBack() {
      this.$emit("prevPage");
    },
    handleSetSelectedSlot(slot) {
      console.log(slot);
      this.selectedSlot = slot;
    },
    handleCopyIban() {
      this.$copyText(this.selectedSlot.iban);
      this.buttonText = "Kopyalandı";
      setTimeout(() => {
        this.buttonText = "Tekrar kopyala";
      }, 1000);
    },
    initial() {
      this.setDescriptions();
    },
    setDescriptions() {
      switch (this.selectedPaymentMethod) {
        case "banktransfer":
          this.title = "Banka Havalesi Cekim Formu";
          this.title2 = this.bank.name + " Banka Bilgilerini Giriniz";
          this.description1 = `Lütfen Cekim yapacaginiz banka bilgilerini giriniz, eger var ise sube kodu ve hesap no giriniz, yok ise IBAN bilgilerini giriniz. Formu doldurduktan sonra 
         sonra 'GÖNDER' butonuna tıklayınız.`;
          this.description2 = `Seçeneklerde uygun banka hesabı bulamadığınız takdirde 17:00'a kadar listedeki herhangi bir bankaya EFT işlemi gerçekleştirebilirsiniz.`;
          this.buttonText = "İbanı kopyaa";
          break;
        case "wallet":
        case "papara":
        case "parazula":
          this.title = "Sanal Cüzdan Yatırım Formu";
          this.title2 = "İşlem yapmak istediğiniz Kurumu Seçiniz";
          this.description1 = `Lütfen işlemi gerçekleştireceğiniz kurumu seçiniz, Daha sonra aşağıda hesap numarası gösterilecektir. Seçilen hesap numarasına ödemeyi
        gerçekleştirdikten sonra 'Gönder' butonuna tıklayınız.`;
          this.buttonText = "Cüzdan numarasını kopyala";
          break;
        case "crypto":
          this.title = "Kripto Para Yatırım Formu";
          this.title2 = "İşlem Yapmak istediğiniz Kripto Parayı Seçiniz";
          this.description1 = `Lütfen işlemi gerçekleştireceğiniz kripto para'yı seçiniz. Daha sonra aşağıda cüzdan bilgisi gösterilecektir. Seçilen cüzdan numarasına ödemeyi
          gerçekleştirdikten sonra 'Gönder' butonuna tıklayınız.`;
          this.buttonText = "Cüzdan numarasını kopyala";
          break;
        default:
          break;
      }
    },
  },
};
</script>

